import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'styles/colors';

const Svg = styled.svg`
  height: 30px;
  width: 30px;
`;

function CheckMark({ className, color = colors.primary.ice }) {
  return (
    <Svg
      viewBox="-6 -6 30 30"
      className={className}
      version="1.1"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 13.775L0.25 7.525L2.0125 5.7625L6.5 10.2375L15.9875 0.75L17.75 2.525L6.5 13.775Z"
        fill={color}
      />
    </Svg>
  );
}

CheckMark.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default CheckMark;
